import { useEffect, useRef } from "react";
import Lenis from "@studio-freight/lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import GlobalPortfolioPage from "./pages/GlobalPortfolioPage";
import UAEPage from "./pages/UAEPage";
import UKPage from "./pages/UKPage";
import PakistanPage from "./pages/PakistanPage";
import InvestmentPhilosophyPage from "./pages/InvestmentPhilosophyPage";
import LegacyVisionPage from "./pages/LegacyVisionPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-champagne">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/portfolio" element={<GlobalPortfolioPage />} />
            <Route path="/portfolio/uae" element={<UAEPage />} />
            <Route path="/portfolio/uk" element={<UKPage />} />
            <Route path="/portfolio/pakistan" element={<PakistanPage />} />
            <Route path="/philosophy" element={<InvestmentPhilosophyPage />} />
            <Route path="/legacy" element={<LegacyVisionPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
